<template>
  <div class="apply" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="sq">
      <div>
        <textarea placeholder="请输入打扫结果" v-model="title"></textarea>
      </div>
      <div style="width:92%;margin:0 auto">
        <img :src="baseUrl+file" v-if="file != ''">
        <div class="pz" @click="getQquey">拍照验收</div>
      </div>
      <div style="width:92%;margin:15px auto" v-if="setDetail1.content !=null">
        审核结果：{{setDetail1.content}}

      </div>
    </div>
    <div class="btn" @click="update" v-if="setDetail1.status !=2 && setDetail1.status !=3">立即提交</div>

  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        username:'',
        file:'33',
        title:'',
        setDetail:[],
        setDetail1:[],
        id:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    created(){
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/cleaner');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }
      this.beforeMount();
      this.getDetail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/cleaner/detail',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.setDetail1 = res.data.res;
          that.title = res.data.rs.title
          that.file = res.data.rs.img
          that.id = res.data.rs.id
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      update:function(){
        var that = this;
        if(that.title == ''){
          alert('打扫结果不能为空');
          return false;
        }
        if(that.file == ''){
          alert('请上传验收图片');
          return false;
        }
        var id = this.$route.query.id;
        that.fullscreenLoading = true;
        this.axios({
          'url': that.$host+'home/cleaner/results',
          'method': 'post',
          params:{
            user_id:that.userData.id,
            title:that.title,
            img:that.file,
            t_id:id,
            id:that.id
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          if(response.data.status == 200){
            that.$router.go(-1);
          }else{
            alert(response.data.message);
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'chooseImage',
              'getLocalImgData'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['chooseImage'],
              success: function (res) {
                wx.chooseImage({
                  count: 1,
                  sizeType: ['compressed'],
                  sourceType: ['camera'], 
                  success: function(res) {
                      that.fullscreenLoading = true;
                      var localId = res.localIds[0].toString();
                      wx.getLocalImgData({
                          localId: localId, // 图片的localID
                          success: function(res) {
                            var u = navigator.userAgent;
                            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
                            var s = res.localData;
                            if(isAndroid){
                              s = 'data:image/jpg;base64,'+res.localData
                            }
                            that.getAjax(s)
                          }
                      });
                  }
                })
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getAjax:function(localData){
        var that = this;
        $.ajax({
          url:this.$host+'home/cleaner/file',
          method: 'post',
          data:{
            localData:localData
          },
          success:function(msg){
            if(msg.status == 200){
              that.file = msg.data
            }
            that.fullscreenLoading = false;
          }
        })
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .apply{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
    padding-bottom:5px;
    padding-top:15px;
  }

  .apply .sq{
    width: 93%;
    display: block;
    background: #fff;
    margin: 0px auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    padding:15px 0
  }
  .apply .sq textarea{
    width:88%;
    display:block;
    margin:0 auto;
    resize:none;
    outline:none;
    padding:1.5% 2%;
    border:solid 1px #ebebeb;
    height:90px;
    border-radius: 5px;
    font-size:15px;
  }

  .apply .sq img{
    width:30%;
    border-radius: 5px;
    margin-top:15px;
    margin-right:15px;
  }
  .apply .sq .pz{
    display:inline-block;
    vertical-align:top;
    margin-top:15px;
    width:30%;
    height:100px;
    border:solid 1px #ebebeb;
    text-align:center;
    line-height:100px;
    font-size:14px;
    color:#666;
  }

  .apply .btn{
    height: 45px;
    background: #007ae6;
    text-align: center;
    line-height: 45px;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    border-radius: 6px;
    width:85%;
    margin:0 auto;
    margin-top:50px
  }

</style>